import axios from 'axios';
import { BulkInsertBody, GetSubjects, InsertSubjects, SetSubjectLink } from 'models/request';
import { BulkInsertResponse, SearchSubject, SuppliersIbanList } from 'models/response';
import { trackPromise } from 'react-promise-tracker';

import { SUBJECT } from '../utils/constants';

/**
 * Get subjects
 * @param {Object} body
 * @param {string} body.key
 * @param {string} body.value
 * @param {number} body.searchType
 * @param {number} body.distance
 * @param {number} body.idCompany
 * @param {number} body.idDocType
 * @param {boolean} body.fromClient
 * @param {string} scopes

 * @return {Promise<AxiosResponse<SearchSubject[]>>}
 */
const getSubjects = (body: GetSubjects, scopes: string) =>
  trackPromise(axios.post<SearchSubject[]>(`${SUBJECT}/searchSubject`, body), scopes);

/**
 *  Link asset to subject
 * @param {Object} body
 * @param {number} body.idSubject
 * @param {number} body.protocol
 * @return {Promise<AxiosResponse<string>>}
 */
const setSubjectLink = (body: SetSubjectLink) => trackPromise(axios.post(`${SUBJECT}/setSubjectLink`, body), 'modal');

/**
 * Insert subjects
 * @param {Object} body
 * @param {string} body.vatNumber
 * @param {string} body.fiscalCode
 * @param {string} body.phone
 * @param {string} body.fax
 * @param {string} body.email
 * @param {string} body.url
 * @param {number} body.status
 * @param {number} body.typology
 * @param {number} body.validationType
 * @param {number} body.blocked
 * @param {number} body.idCompany
 * @param {string} body.iban
 * @param {number} body.debitCredit
 * @param {string} body.subject
 * @param {string} body.address
 * @param {number} body.country
 * @param {string} body.fiscalCode

 * @return {Promise<AxiosResponse>}
 */
const insertSubject = (body: InsertSubjects) => trackPromise(axios.post(`${SUBJECT}/insert`, body), 'modal');

/**
 * get base64 of csv template
 * @return {Promise<AxiosResponse<string>>}
 */
const getCsvTemplateForCreateSubjectByFile = () =>
  trackPromise(axios.post(`${SUBJECT}/getCsvTemplateForCreateSubjectByFile`), 'modal');

/**
 * Multiple csv new story functionality
 * @param {Object} body
 * @param {number} body.idCompany
 * @param {string} body.base64Csv
 * @return {Promise<AxiosResponse>}
 */
const bulkInsert = (body: BulkInsertBody) =>
  trackPromise(axios.post<BulkInsertResponse>(`${SUBJECT}/bulkInsert`, body), 'modal');

/**
 * @param {Object} body
 * @param {number} body.idCompany
 * @param {string} body.supplierCode
 * @return {Promise<AxiosResponse>}
 */
const getOSuppliersIbanList = (body: { idCompany: number; supplierCode: string }) =>
  trackPromise(axios.post<SuppliersIbanList[]>(`${SUBJECT}/getOSuppliersIbanList`, body), 'modal');

/**
 * Search Subject By Id
 * @param {number} idSubject
 * @return {Promise<AxiosResponse<string>>}
 */
const searchSubjectById = (idSubject: number) =>
  trackPromise(
    axios.post<{ subject: number; vatNumber: string }>(`${SUBJECT}/searchSubjectById`, { idSubject }),
    'modal',
  );

/**
 * Dissociate linked asset
 * @param {number} idSubject
 * @return {Promise<AxiosResponse<string>>}
 */
const unsetSubjectLink = (idSubject: number) =>
  trackPromise(axios.post(`${SUBJECT}/unsetSubjectLink`, { idSubject }), 'modal');

export default {
  getSubjects,
  setSubjectLink,
  insertSubject,
  getCsvTemplateForCreateSubjectByFile,
  bulkInsert,
  getOSuppliersIbanList,
  searchSubjectById,
  unsetSubjectLink,
};
